// @ts-nocheck
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  PublicLayout,
  AboutPage,
  BlogPage,
  BlogPostPage,
  FAQPage,
  LegalPage,
  ContactModal,
  LanguageModal,
  HelpCenterModal,
  GlobalStyle,
} from '../app-ui'
import { useApp } from '../context/app-context'
import { PUBLIC_LOCALES, splitLocalizedPath, withLocalePath } from '../lib/public-route-locale'
import { hreflangByLocale } from '../lib/public-seo'

export default function PublicContentPage() {
  const app = useApp()
  const { pathname } = useLocation()
  const { locale, basePath } = splitLocalizedPath(pathname)
  const scopedNavigate = (path) => (locale ? app.navigate(withLocalePath(path, locale)) : app.navigate(path))

  useEffect(() => {
    const canonicalPath = locale ? withLocalePath(basePath, locale) : basePath
    const canonicalHref = `https://www.bookbuildergo.com${canonicalPath === '/' ? '' : canonicalPath}`
    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', canonicalHref)
    for (const alt of PUBLIC_LOCALES) {
      const hreflang = hreflangByLocale[alt]
      const href = `https://www.bookbuildergo.com${withLocalePath(basePath, alt)}`
      let altLink = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`)
      if (!altLink) {
        altLink = document.createElement('link')
        altLink.setAttribute('rel', 'alternate')
        altLink.setAttribute('hreflang', hreflang)
        document.head.appendChild(altLink)
      }
      altLink.setAttribute('href', href)
    }
    // x-default → the English version of this page
    const xDefaultHref = `https://www.bookbuildergo.com${withLocalePath(basePath, 'en')}`
    let xDefault = document.head.querySelector('link[rel="alternate"][hreflang="x-default"]')
    if (!xDefault) {
      xDefault = document.createElement('link')
      xDefault.setAttribute('rel', 'alternate')
      xDefault.setAttribute('hreflang', 'x-default')
      document.head.appendChild(xDefault)
    }
    xDefault.setAttribute('href', xDefaultHref)
  }, [basePath, locale])

  const publicPageProps = {
    lang: app.lang,
    setLang: app.setLang,
    navigate: scopedNavigate,
    onLogin: () => app.navigate('/login'),
    onSignup: () => app.navigate('/signup'),
    onDashboard: () => app.navigate(app.isPaidPlan ? '/dashboard' : '/plans'),
    authUser: app.authUser,
    subscription: app.subscription,
    authLoading: app.authLoading,
    onContact: () => app.setContactOpen(true),
    onHelpCenter: () => app.setHelpCenterOpen(true),
    onLanguages: () => app.setLanguageOpen(true),
  }

  let content = null
  if (basePath === '/about') content = <AboutPage lang={app.lang} />
  else if (basePath === '/blog') content = <BlogPage lang={app.lang} navigate={scopedNavigate} locale={locale || 'en'} />
  else if (basePath === '/faq') content = <FAQPage lang={app.lang} />
  else if (basePath === '/terms') content = <LegalPage type="terms" lang={app.lang} />
  else if (basePath === '/privacy') content = <LegalPage type="privacy" lang={app.lang} />
  else if (basePath.startsWith('/blog/')) {
    content = (
      <BlogPostPage
        lang={app.lang}
        navigate={scopedNavigate}
        locale={locale || 'en'}
        slug={basePath.replace(/^\/blog\//, '')}
      />
    )
  }

  if (!content) return null

  return (
    <>
      <GlobalStyle />
      <PublicLayout {...publicPageProps}>{content}</PublicLayout>
      <ContactModal open={app.contactOpen} onClose={() => app.setContactOpen(false)} lang={app.lang} />
      <LanguageModal
        open={app.languageOpen}
        onClose={() => app.setLanguageOpen(false)}
        lang={app.lang}
        setLang={app.setLang}
        navigate={scopedNavigate}
      />
      <HelpCenterModal
        open={app.helpCenterOpen}
        onClose={() => app.setHelpCenterOpen(false)}
        lang={app.lang}
      />
    </>
  )
}
